import { Linking, StyleSheet, View } from "react-native";
import { fp, spH, spV, wp } from "utils/normalise";

import ParentScrollView from "components/ParentScrollView";
import VText from "components/VText";
import Heading from "components/Heading";
export default function TermsAndConditions({_scrollRef} ) {
    return (
        <ParentScrollView _scrollRef={_scrollRef}>
            <View style={styles.container}>
                <View
                    style={{
                        ...styles.headingContainer,
                        // marginTop: spV(80),
                        alignItems: "center",
                    }}
                >
                    <Heading type="h1" style={styles.aboutHeadingText}>Terms & Conditions</Heading>
                </View>
                <View
                    style={{
                        ...styles.textContainer,
                        marginTop: spV(10),
                        flexDirection: "row",
                        justifyContent: "left",
                        gap: spH(1),
                    }}
                >
                    <VText
                        style={{
                            fontSize: "1rem",
                            fontWeight: "550",
                            lineHeight: 33,
                            textAlign: "center",
                        }}
                    >
                        Last Updated:{" "}
                    </VText>
                    <VText
                        style={{
                            fontSize: "1rem",
                            fontWeight: "350",
                            lineHeight: 33,
                            textAlign: "center",
                        }}
                    >
                        Nov 2022
                    </VText>
                </View>
                <View
                    style={{
                        ...styles.aboutTextContainer,
                        textAlign: "left",
                        marginTop: "2vh",
                    }}
                >
                    <VText style={styles.paragraphText}>Welcome to Vetir ("we", "us" or “our").</VText>
                    <VText style={styles.paragraphText}>
                        These Terms of Use ("Terms") govern your use of our Website and Apps (Service). When you sign in
                        on our Service or use it, you agree to these terms. This terms applies to our website and mobile
                        applications - Vetir (Android/iOS).
                    </VText>
                    <VText style={styles.paragraphText}>
                        Data Policy: Data privacy regulations are enclosed in our Privacy Policy.
                    </VText>
                    <VText style={styles.paragraphText}>
                        User Commitments: You must be at least 13 years old. If you are under the age of 18, you uses
                        this Site under the supervision of a parent or legal guardian who agrees to be bound by these
                        Terms of Use. You can’t do anything unlawful, misleading, or fraudulent or for an illegal or
                        unauthorized purpose. You can't post someone else’s private or confidential information without
                        permission or do anything that violates someone else's rights, including intellectual property
                        rights (e.g., copyright infringement, trademark infringement, counterfeit, or pirated goods).
                        You can't impersonate others or provide inaccurate information. You can't do anything to
                        interfere with or impair the intended operation of the Service. You can't use any program to
                        gather or crawl information from our Service.
                    </VText>
                    <VText style={styles.paragraphText}>
                        Permissions You Give to us: We do not claim ownership of your post content, but you grant us a
                        license to use it. All of the information you have added can be used in impersonal form for
                        machine learning to provide better service to users. We can remove any content or information
                        you shared on the service if we believe that it violates our terms of use & policies.
                    </VText>
                    <VText style={styles.paragraphText}>
                        Disclosure: We may earn a commission when you use one of our coupons/links to make a purchase.
                    </VText>
                    <VText style={styles.paragraphText}>
                        Updating These Terms: We may modify or update these Terms from time to time. Your continued use
                        of the service after any modification to this these Terms will constitute your acceptance of
                        such modification.
                    </VText>
                    <VText style={styles.paragraphText}>
                        Contact us: Please submit any questions or concerns you have about this terms by email to{" "}
                        <VText
                            style={{ color: "#000000", textDecorationLine: "underline" }}
                            onPress={() => {
                                Linking.openURL("mailto:admin@vertirapp.com?subject=Terms of Use");
                            }}
                        >
                            admin@vertirapp.com
                        </VText>{" "}
                        with details.
                    </VText>
                    <VText style={styles.paragraphText}>Date of Last Revision: Nov 2022</VText>
                    <VText style={styles.paragraphText}>© 2022 Bond NYC. All Rights Reserved.</VText>
                </View>
            </View>
        </ParentScrollView>
    );
}
const styles = StyleSheet.create({
    container: {
        flex: 1,
        backgroundColor: "white",
        paddingBottom: "1vh",
        width: "auto",
        marginTop: "4vh",
        marginHorizontal: "4vw",
    },
    headingContainer: {
        alignItems: "center",
    },
    headingText: {
        textAlign: "center",
        fontSize: "2rem",
        fontFamily: "LibreBodoni",
        fontWeight: "350",
    },
    dateContainer: {
        marginTop: "4vh",
        flexDirection: "row",
        justifyContent: "left",
        gap: "0.0625rem",
    },
    dateText: {
        fontSize: "1rem",
        fontWeight: "550",
        textAlign: "center",
    },
    dateValue: {
        fontSize: "1rem",
        fontWeight: "350",
        textAlign: "center",
    },
    textContainer: {
        marginTop: "2vh",
    },
    paragraphText: {
        padding: 0,
        fontSize: "1rem",
        fontWeight: "350",
        lineHeight: "1.5rem",
        textAlign: "left",
        marginBottom: "4vh",
    },
    boldParagraphText: {
        fontSize: "1rem",
        lineHeight: "1.5rem",
        textAlign: "left",
        fontWeight: "500",
        marginBottom: "0.5vh",
    },
    contactEmail: {
        color: "#000000",
        // textDecorationLine: "underline",
    },
});
